import { Component, EventEmitter } from '@angular/core';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { BaseCrudComponent } from 'app/base';
import { MenuItem } from 'primeng/components/common/menuitem';
import { GerenciamentoCurso } from 'app/entity/gerenciamento-curso.model';
import { requiredMinLength, requiredMaxLength } from 'app/util/custom.validators';
import { HomologacaoCurso } from '../../entity/homologacao-curso.model';
import { AnexoCurso } from 'app/entity/anexo-curso.model';
import { isNullOrUndefined } from 'util';
import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { cabecalho } from 'app/entity/cabecalho-prestacao-conta.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'gerenciamento-curso-crud',
    templateUrl: 'gerenciamento-curso-crud.component.html'
})

export class CrudGerenciamentoCursoComponent extends BaseCrudComponent {
    listaResumo: any[];
    listaRelatores: SelectItem[] = [];
    controllerName = 'gerenciamentoCurso';
    id: number;

    codigoCurso: string;

    cabecalhoSomatorio: cabecalho[] = [];

    listaCapacitadora: SelectItem[] = [];
    listaAbrangencia: SelectItem[] = [];
    listaModalidade: SelectItem[] = [];
    listaTipoAtividade: SelectItem[] = [];
    listaAreaTematica: SelectItem[] = [];
    listaPublicoAlvo: SelectItem[] = [];
    listaCriterioAvaliacao: SelectItem[] = [];
    listaConteudo: any[] = [];
    listaTurma: any[] = [];
    listaUf: any[] = [];
    listaDiasSemana: SelectItem[] = [];
    listaPais: SelectItem[] = [];
    listaMunicipios: SelectItem[] = [];
    listaInstrutores: any[] = [];
    listaBibliografia: any[] = [];
    idHomologacao: number;
    validateForm: any = false;

    isValid = false;

    uploadedFiles: any[] = [];
    anexo_curso: AnexoCurso = new AnexoCurso;


    gerenciamentoCurso: GerenciamentoCurso = new GerenciamentoCurso;
    homologacaoCurso: HomologacaoCurso = new HomologacaoCurso;

    stepObject: any;
    capacitadora: any;
    listaPntCFC: any[];
    listaPntCRC: any[];

    hoje = new Date();

    // GERENCIAMENTO_CURSO_ETAPA_4
    listaCursos: SelectItem[] = []
    listaFormacaoAcademico: any[] = [];
    listaFormacaoInstrutor: any[] = [];
    uploadedFilesInstrutor: any[] = [];

    storagedListFiles: any[];
    uploadedFilesChange = new EventEmitter<any>();
    uploadedFilesTemp: any[] = [];

    displayDialog: boolean;

    recurso: RecursoFiltro = new RecursoFiltro();

    etapas: MenuItem[] = [
        { label: 'Curso' },
        { label: 'Turma' },
        { label: 'Instrutor' },
        { label: 'Resumo' }
    ];
    cadastro = this.formBuilder.group({
        etapa1: this.formBuilder.group({
           
            conteudo: this.formBuilder.group({
                descricao: [null, [Validators.required, Validators.maxLength(4000), requiredMinLength(1),]],
                titulo: [null, [Validators.required, Validators.maxLength(255), requiredMinLength(1),]],
                id: [null]
            }),
            observacao: this.formBuilder.group({
                observacao: [null, [Validators.maxLength(4000)]],
            }),
            anexo_curso: this.formBuilder.group({
                id: [null]
            }),
            curso: this.formBuilder.group({
                bibliografia_curso: this.formBuilder.group({
                    id: [null],
                    bibliografia: [null, [Validators.maxLength(4000)]],
                }),
                codigo_curso_capacitadora: [null, Validators.maxLength(100)],
                curso_criterio_avaliacao: this.formBuilder.group({
                    id_criterio_avaliacao: [null],
                    id_curso: [null],
                    id: [null],
                    list: [null, [Validators.required]],
                }),
                curso_publico_alvo: this.formBuilder.group({
                    id_publico_alvo: [null],
                    id_curso: [null],
                    id: [null],
                    list: [null, [Validators.required]]
                }),
                curso_area_tematica: this.formBuilder.group({
                    id_area_tematica: [null],
                    id_curso: [null],
                    id: [null],
                    list: [null, [Validators.required]]
                }),
                id_tipo_atividade: [null, [Validators.required]],
                id_modalidade: [null, [Validators.required]],
                id_abrangencia: [null, [Validators.required]],
                frequencia_minima: [null, [Validators.required, Validators.min(0), requiredMaxLength(10, true)]],
                carga_horaria: [null, [Validators.required, Validators.min(0), requiredMaxLength(10, true)]],
                titulo_traduzido: [null, [requiredMaxLength(255, true)]],
                titulo_original: [null, [Validators.required, requiredMinLength(1), requiredMaxLength(255, true)],],
                id_capacitadora: [null, [Validators.required]],
                id: [null],
                codigo: [null],
                id_situacao: [null],
                codigo_capacitadora: [null],
                data_cadastro: [null],
                data_envio: [null],
                data_validade: [null]
            }),
        }),

        etapa2: this.formBuilder.group({
            turma_titulo: [null, [Validators.required, Validators.maxLength(150), requiredMinLength(1)]],
            data_inicio: [this.hoje, [Validators.required]],
            data_fim: [this.hoje, [Validators.required]],
            turma_dia_semana: this.formBuilder.group({
                id_dia_semana: [null],
                id_turma: [null],
                id: [null],
                list: [null, [Validators.required]]
            }),
            id_pais: [null, [Validators.required]],
            id_uf: [null],
            id_cidade: [null],
            id: [null]

        }),

        etapa3: this.formBuilder.group({
            curso_instrutor: this.formBuilder.group({
                id: [null],
                id_curso: [null],
                id_instrutor: [null],
                list: [null, [Validators.required]]
            })
        }),

        etapa4: this.formBuilder.group({}),
    });

    setStepObject(obj: any) {
        this.stepObject = obj;
    }
    init() {

        // modificar ao final a route para capacitadora
        this.service.ListarTodos('capacitadora', { query: 'deferido' }).subscribe(data => {
            this.listaCapacitadora = data;
        });
        this.service.ListarTodos('abrangencia', { query: 'ativo' }).subscribe(data => {
            this.listaAbrangencia = data;
        });
        this.service.ListarTodos('modalidade', { query: 'ativo' }).subscribe(data => {
            this.listaModalidade = data;
        });
        this.service.ListarTodos('natureza', { query: 'curso' }).subscribe(data => {
            this.listaTipoAtividade = data;
        });
        this.service.ListarTodos('areaTematica', { query: 'ativo' }).subscribe(data => {
            this.listaAreaTematica = data;
        });
        this.service.ListarTodos('publicoAlvo', { query: 'ativo' }).subscribe(data => {
            this.listaPublicoAlvo = data;
        })
        this.service.ListarTodos('criterioAvaliacao', { query: 'ativo' }).subscribe(data => {
            this.listaCriterioAvaliacao = data;
        })
        this.service.ListarTodos('uf').subscribe(data => {
            this.listaUf = data;
        })
        this.service.ListarTodos('combo/dia_semana').subscribe(data => {
            this.listaDiasSemana = data;
        })
        this.service.ListarTodos('pais').subscribe(data => {
            this.listaPais = data;
        })
        this.service.ListarTodos('cidade').subscribe(data => {
            this.listaMunicipios = data;
        })
        this.service.ListarInstrutores('instrutor').subscribe(data => {
            this.listaInstrutores = data;
        })
        this.hoje = new Date(this.hoje.setDate(new Date().getDate() + 5));
    }

    afterLoad() {
        if (this.acao !== 'cadastrar') {
            if (this.acao === 'visualizar') {
                super.init();
            }
        }

        if (this.obj.anexo_curso != null) {
            this.obj.anexo_curso.forEach(x => {
                x.show = true;
                this.uploadedFiles.push(x);
            });
        }

        const listPublico = this.obj.curso_publico_alvo.map(item => {
            return item.id_publico_alvo;
        })
        const listCriterio = this.obj.curso_criterio_avaliacao.map(item => {
            return item.id_criterio_avaliacao;
        })
        const listArea = this.obj.curso_area_tematica.map(item => {
            return item.id_area_tematica;
        })
        const listInst = this.obj.curso_instrutor.map(item => {
            return item.id_instrutor;
        })

        // VisualizarObservaçõesCurso
        this.cadastro.get('etapa1.observacao.observacao').patchValue(this.obj.observacao);

        this.codigoCurso = this.obj.codigo;

        const lst = [];
        if (!isNullOrUndefined(this.obj.bibliografia)) {
            lst.push({
                id: null,
                bibliografia: this.obj.bibliografia,
                id_curso: this.obj.id,
            });
            this.obj.bibliografia_curso.push(...lst);
        }
        this.listaBibliografia = this.obj.bibliografia_curso

        this.obj.homologacao_curso.map(item => {
            this.homologacaoCurso = item;
            this.service.ListarRelatores('listaRelatoresHomologacao', { query: item.id }).subscribe(
                data => {
                    this.listaRelatores = data;
                  }
              );
            this.service.ListarTodos('resumoHomologacao', { query: item.id }).subscribe(
                data => {
                    this.listaResumo = data;
                }
            );
            this.service.ListarPontuacaoHomologacao('homologacaoCurso', item.id, 'Comissão CFC').subscribe(retorno => {
                this.listaPntCFC = retorno;
            });
            this.service.ListarPontuacaoHomologacao('homologacaoCurso', item.id, 'Comissão CRC').subscribe(retorno => {
                this.listaPntCRC = retorno;
            });
        });
        // listaCriterioAvaliacao
        this.cadastro.get('etapa1.curso.curso_criterio_avaliacao.list').patchValue(listCriterio);
        // listaPublicoAlvo
        this.cadastro.get('etapa1.curso.curso_publico_alvo.list').patchValue(listPublico);
        // listaAreaTematica
        this.cadastro.get('etapa1.curso.curso_area_tematica.list').patchValue(listArea);
        // listaConteudo
        this.listaConteudo = this.obj.conteudo;
        // listaTurma
        this.service.ListarTodos('Turma', { id_curso: this.obj.id }).subscribe(
            data => {
                this.listaTurma = data;
            }
        );
        // listaInstrutor
        this.cadastro.get('etapa3.curso_instrutor.list').patchValue(listInst);
        // Curso
        this.cadastro.get('etapa1.curso').patchValue(this.obj);

        this.cadastro.get('etapa1.curso.codigo_capacitadora').patchValue(this.obj.capacitadora.codigo);

        this.capacitadora = this.obj.capacitadora;
    }


    recarregarListaInstrutores() {
        this.displayDialog = false;
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.listaInstrutores = [];
        this.service.ListarInstrutores('instrutor').subscribe(data => {
            this.listaInstrutores = data;
        });
        this.observableUtilPanelDoc.setBlockedPanel(false);
    }

    finalizar() {
        // curso
        this.gerenciamentoCurso.id = this.cadastro.get('etapa1.curso.id').value;
        this.gerenciamentoCurso.titulo_original = this.cadastro.get('etapa1.curso.titulo_original').value;
        this.gerenciamentoCurso.titulo_traduzido = this.cadastro.get('etapa1.curso.titulo_traduzido').value;
        this.gerenciamentoCurso.carga_horaria = this.cadastro.get('etapa1.curso.carga_horaria').value;
        this.gerenciamentoCurso.frequencia_minima = this.cadastro.get('etapa1.curso.frequencia_minima').value;
        this.gerenciamentoCurso.id_abrangencia = this.cadastro.get('etapa1.curso.id_abrangencia').value;
        this.gerenciamentoCurso.id_modalidade = this.cadastro.get('etapa1.curso.id_modalidade').value;
        this.gerenciamentoCurso.id_tipo_atividade = this.cadastro.get('etapa1.curso.id_tipo_atividade').value;
        this.gerenciamentoCurso.codigo_curso_capacitadora = this.cadastro.get('etapa1.curso.codigo_curso_capacitadora').value;
        // this.gerenciamentoCurso.bibliografia = this.cadastro.get('etapa1.curso.bibliografia').value;
        this.gerenciamentoCurso.id_capacitadora = this.cadastro.get('etapa1.curso.id_capacitadora').value;
        this.gerenciamentoCurso.id_situacao = this.cadastro.get('etapa1.curso.id_situacao').value;
        this.gerenciamentoCurso.codigo = this.cadastro.get('etapa1.curso.codigo').value;
        this.gerenciamentoCurso.observacao = this.cadastro.get('etapa1.observacao.observacao').value;
        this.gerenciamentoCurso.data_cadastro = this.cadastro.get('etapa1.curso.data_cadastro').value;
        var datavalidade = new Date();
        var ano = datavalidade.getFullYear() + 1;
        datavalidade.setFullYear(ano, 11, 31);
        this.gerenciamentoCurso.data_validade = datavalidade;


        // Conteudo
        this.gerenciamentoCurso.conteudo = this.listaConteudo.map(item => {
            item.id_curso = this.gerenciamentoCurso.id;
            item.curso = null;
            return item;
        });

        // Anexo
        this.gerenciamentoCurso.anexo_curso = [];
        this.uploadedFiles.forEach(item => {
            this.gerenciamentoCurso.anexo_curso.push(item);
        });

        // Turma
        this.gerenciamentoCurso.turma = this.listaTurma.map(item => {
            item.id_curso = this.gerenciamentoCurso.id;
            item.curso = null;
            // tslint:disable-next-line: no-shadowed-variable
            item.turma_dia_semana = item.turma_dia_semana.map(item => {
                item.id = null;
                item.dia_semana = null;
                return item;
            });
            return item;
        });
        // Instrutor
        this.gerenciamentoCurso.curso_instrutor = this.cadastro.get('etapa3.curso_instrutor.list').value.map(item => {
            const valor = { id_instrutor: item, id_curso: this.gerenciamentoCurso.id };
            return valor;
        });
        // Curso-Criteiro Avaliação
        // tslint:disable-next-line: max-line-length
        this.gerenciamentoCurso.curso_criterio_avaliacao = this.cadastro.get('etapa1.curso.curso_criterio_avaliacao.list').value.map(item => {
            const valor = { id_criterio_avaliacao: item, id_curso: this.gerenciamentoCurso.id };
            return valor;
        });
        // Curso-Publico Alvo
        this.gerenciamentoCurso.curso_publico_alvo = this.cadastro.get('etapa1.curso.curso_publico_alvo.list').value.map(item => {
            const valor = { id_publico_alvo: item, id_curso: this.gerenciamentoCurso.id };
            return valor;
        });
        // Curso-Area Tematica
        this.gerenciamentoCurso.curso_area_tematica = this.cadastro.get('etapa1.curso.curso_area_tematica.list').value.map(item => {
            const valor = { id_area_tematica: item, id_curso: this.gerenciamentoCurso.id };
            return valor;
        });
        if (this.acao === 'cadastrar') {
            this.gerenciamentoCurso.id_situacao = 16;
        }

        // Bibliografia Curso
        this.gerenciamentoCurso.bibliografia_curso = this.listaBibliografia.map(item => {
            item.id_curso = this.gerenciamentoCurso.id;
            return item;
        });

        this.doFinalAction(this.gerenciamentoCurso, this.controllerName);
    }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-curso/crud/gerenciamento-curso-crud.component.ts